export default __webpack_public_path__ + "static/media/logo.fcacb829.png";